(function (app, ng) {
    app.component("transactionGroupBasicInfo",
        {
            controller: transactionGroupBasicInfoController,
            templateUrl: "/App/Dashboard/ConfigureTransactionGroup/BasicInfo/basic-info-template.html",
            bindings: {
                transactionGroup: "<",
                transactionGroupBusiness: "<",
                //businesses: "<",
                logo: "<",
                onPublish: "&"
            }
        });

    transactionGroupBasicInfoController.$inject = ["_", "businessApi", "permissionService", "$q", "transactionGroupApi"];
    function transactionGroupBasicInfoController(_, businessApi, permissionService, $q, transactionGroupApi) {
        var $ctrl = this;
        ng.extend($ctrl,
            {
                UI: {},
                businesses: [],
                searchText: '',
                permissionService: permissionService,
                removeLogo: removeLogo,
                searchBusinesses: searchBusinesses,
                updateLogo: updateLogo,
                updateTransactionGroup: updateTransactionGroup
            });

        this.$onInit = function () {
            if ($ctrl.transactionGroupBusiness)
                $ctrl.businesses.push($ctrl.transactionGroupBusiness);
        };

        function updateLogo(file) {
            if (file !== null) {
                var payload = new FormData();
                payload.append("logo", $ctrl.logo, $ctrl.logo.name);

                transactionGroupApi.updateLogo($ctrl.transactionGroup.Id, payload);
            }
        }

        function removeLogo() {
            transactionGroupApi.removeLogo($ctrl.transactionGroup.Id).then(function () {
                $ctrl.logo = null;
            });
        }

        function updateTransactionGroup() {
            console.log($ctrl.transactionGroupBusiness);
            var promise = [];
            if ($ctrl.transactionGroupBusiness)
                promise.push(businessApi.add({
                    Name: $ctrl.transactionGroupBusiness.Name,
                    ArcBusinessId: $ctrl.transactionGroupBusiness.ArcBusinessId
                }).then(function (response) {
                    $ctrl.transactionGroup.BusinessId = response.Id;
                }));

            $q.all(promise).then(function () {
                transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
            });
        }

        function searchBusinesses(searchTerm) {
            searchTerm = searchTerm.toLowerCase();
            //var results = !!searchTerm
            //    ? _.filter($ctrl.businesses, function (row) { return row.Name.toLowerCase().indexOf(searchTerm) !== -1; })
            //    : $ctrl.businesses;
            //return results;
            return businessApi.searchArcBusinesses(searchTerm)
                .then(function (result) {
                    return result;
                })
                .catch(function (error) {
                    console.log("Error", error);
                });
        }
    }
})(window.app, window.angular); //jshint ignore:line